module.exports = __webpack_public_path__ + "static/windsorcensusmaps-1b32dffde2a699184a157e46c39eee7d.png";